export const ROUTENAMES = {
  HOME: 'home',
  LOGIN: 'login',
  REPORT: 'report',
  FORBIDDEN: 'forbidden',
  UNAUTHORIZED: 'unauthorized',
};
